import { actionTypes } from "./actions";
import { immutableSet } from "../../../../../utils/immutable";
import { compose } from "redux";
import { IAction } from "../../../../../models/Action";
import {
  IReportEnrichment,
  IReportParameterEnrich,
  IReportParameterUnique,
} from "../../module/constants";
import { IResponseState } from "../../../../../components/Modals/ResponseModal/module/constants";
import emptyState from "./emptyState";
import { STATE_IDENTIFIER } from "./constants";

const { PARAMETERS, PARAM_DEL_STATE, PARAM_ADD_EDIT_STATE, LOADER_IDENTIFIER } =
  STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_PARAMETERS]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_PARAMETERS_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([PARAMETERS], []),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.GET_PARAMETERS_SUCCESS]: (state: any, action: any) => {
    let tmpList: IReportParameterUnique[] = [];

    action.payload.forEach((elem: IReportParameterEnrich) => {
      if (elem.enrichments && elem.enrichments.length > 0) {
        elem.enrichments.forEach((el: IReportEnrichment) => {
          tmpList.push({
            uniqueId: `${elem.parameter}-${el.property}-${el.value}`,
            parameter: elem.parameter,
            property: el.property,
            value: el.value,
          });
        });
      }
    });
    return compose(
      immutableSet([PARAMETERS], tmpList),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.POST_PARAMETER]: (state: any, action: any) =>
    immutableSet([PARAM_ADD_EDIT_STATE], IResponseState.PENDING, state),
  [actionTypes.POST_PARAMETER_SUCCESS]: (state: any, action: any) =>
    immutableSet([PARAM_ADD_EDIT_STATE], IResponseState.SUCCESS, state),
  [actionTypes.POST_PARAMETER_FAILURE]: (state: any, action: any) =>
    immutableSet([PARAM_ADD_EDIT_STATE], IResponseState.ERROR, state),

  [actionTypes.PUT_PARAMETER]: (state: any, action: any) =>
    immutableSet([PARAM_ADD_EDIT_STATE], IResponseState.PENDING, state),
  [actionTypes.PUT_PARAMETER_SUCCESS]: (state: any, action: any) =>
    immutableSet([PARAM_ADD_EDIT_STATE], IResponseState.SUCCESS, state),
  [actionTypes.PUT_PARAMETER_FAILURE]: (state: any, action: any) =>
    immutableSet([PARAM_ADD_EDIT_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_PARAMETER]: (state: any, action: any) =>
    immutableSet([PARAM_DEL_STATE], IResponseState.PENDING, state),
  [actionTypes.DELETE_PARAMETER_SUCCESS]: (state: any, action: any) =>
    immutableSet([PARAM_DEL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.DELETE_PARAMETER_FAILURE]: (state: any, action: any) =>
    immutableSet([PARAM_DEL_STATE], IResponseState.ERROR, state),
};

// Reducer
export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
